import { render, staticRenderFns } from "./badgeProcessApproval.vue?vue&type=template&id=61c351bf&scoped=true&"
import script from "./badgeProcessApproval.vue?vue&type=script&lang=js&"
export * from "./badgeProcessApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c351bf",
  null
  
)

export default component.exports